import { IWatrPaymentError, IWatrRequest } from '@nkr/models/index';
import { useState } from 'react';
import { Button, ControlLabel, FormControl, FormGroup, HelpBlock, Modal } from 'react-bootstrap';

interface IProps {
    show: boolean,
    data: IWatrRequest,
    onPaymentErrorUpdate: (paymentError: IWatrPaymentError) => void
    onClose: () => void,
}

const PaymentError = (props: IProps) => {
    if (!props.show || props.data == null)
        return null;
    
    const isResolution = props.data.paymentErrors.some(e => !e.isResolved);
    const currentError = props.data.paymentErrors.find(e => !e.isResolved);
    const [description, setDescription] = useState<string>('')

    const createPaymentError = () => {
        props.onPaymentErrorUpdate({
            requestId: props.data.id,
            isResolved: false,
            description: description
        });
        setDescription('');
    }

    const resolvePaymentError = () => {
        props.onPaymentErrorUpdate({
            ...currentError,
            isResolved: true
        });
        setDescription('');
    }

    const valid:boolean = isResolution || description.trim().length > 0;

    return (
        <Modal backdrop='static' show={props.show} onHide={props.onClose}>
            <Modal.Header closeButton>
                <Modal.Title>
                    {isResolution ? `Resolve` : `Move to`} Payment Error - {`${props.data.firstName}  ${props.data.lastName}`}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <FormGroup controlId="formControlsTextarea">
                    <ControlLabel>Error Description</ControlLabel>
                    <FormControl 
                        componentClass="textarea" 
                        placeholder="Please enter a description of the payment error." 
                        disabled={isResolution}
                        value={isResolution ? currentError.description : description}
                        maxLength={440}
                        style={{minHeight:'200px'}}
                        onChange={(e: React.FormEvent<FormControl & HTMLInputElement>) => setDescription(e.currentTarget.value)}
                    />
                    {!isResolution && <HelpBlock>Required (440 character maximum).</HelpBlock>}
                </FormGroup>
            </Modal.Body>
            <Modal.Footer>
                {isResolution 
                    ? <Button bsStyle="success" onClick={() => resolvePaymentError()}>Resolve Payment Error</Button>
                    : <Button bsStyle="danger" onClick={() => createPaymentError()} disabled={!valid}>Flag Payment Error</Button>
                }           
                <Button onClick={props.onClose}>Cancel</Button>
            </Modal.Footer>
        </Modal>
    );
}

export default PaymentError;